const staticPages = {
    comingSoon: 'Sayfa hala geliştirilme aşamasındadır',
};

export default staticPages;
